module.exports = __webpack_public_path__ + "img/finance-info.92f0e24b.svg";